
export function  isEmpty(data) {
    return ((data != null) && (data != undefined) && (data.length > 0) ? false : true);
}

export function  isNull(data) {
    return ((data != null) && (data != undefined) && (data != "null") ? false : true);
}

export function isSuccess(str) {
    return ((str == "true") || (str == "True") || (str == true) ? true : false);
} 

export function isNullOrEmpty(str) {
    return  (!str || (str == "null")? true: false);
}

export function isNullOrWhiteSpace(str) {
    return  (!str || (str == "null") || (str.trim() == "")? true: false);
}

export function getStringFormatPlaceHolderRegEx(placeHolderIndex) {
    return new RegExp('({)?\\{' + placeHolderIndex + '\\}(?!})', 'gm')
}

export function cleanStringFormatResult(txt) {
    if (txt == null) return "";
    return txt.replace(getStringFormatPlaceHolderRegEx("\\d+"), "");
} 
  
export function stringFormat() {
    var s = arguments[0];
    if (s == null) {
      return "";
    }
    for (var i = 0; i < arguments.length - 1; i++) {
      var reg = getStringFormatPlaceHolderRegEx(i);
      s = s.replace(reg, (arguments[i + 1] == null ? "" : arguments[i + 1]));
    }
    return cleanStringFormatResult(s);
}

export function addLeftZero(param) {
    if (param < 10) {
      param = stringFormat("0{0}", param);
    }
    return param;
}

export function checkDateTime (dt) {
    var ret = false;
    var date = null;

    if (null != dt) {
      var y1 = 0;
      if (typeof dt == "string") {
        date = new Date(dt);
      } else {
        date = dt;
      }

      y1 = date.getFullYear();
      ret = (y1 > 1900);
    }
    return ret;  
}

export function checkIdentifyNumber(idNumber){
    var checkFg = false;
    var msg = '';
    var oIdNumber = idNumber.toUpperCase();
     
    console.log('======checkIdentifyNumber=====');
    if(oIdNumber.length != 10){
        return '證號長度不足';
    }
    else {
        var idHeader = "ABCDEFGHJKLMNPQRSTUVXYWZIO"; //按照轉換後權數的大小進行排序

        //本國人 
        //驗證填入身分證字號長度及格式
        //用正則表示式比對第一個字母是否為英文字母
        if (!isNaN(oIdNumber.substr(1,9)) &&
           (/^[A-Z]$/.test(oIdNumber.substr(0,1)))){
            
            //這邊把身分證字號轉換成準備要對應的
            var studIdNumber = (idHeader.indexOf(oIdNumber.substring(0,1))+10) +''+ oIdNumber.substr(1,9);
            //開始進行身分證數字的相乘與累加，依照順序乘上1987654321
            var s = parseInt(studIdNumber.substr(0,1)) + 
                    parseInt(studIdNumber.substr(1,1)) * 9 + 
                    parseInt(studIdNumber.substr(2,1)) * 8 + 
                    parseInt(studIdNumber.substr(3,1)) * 7 +            
                    parseInt(studIdNumber.substr(4,1)) * 6 + 
                    parseInt(studIdNumber.substr(5,1)) * 5 + 
                    parseInt(studIdNumber.substr(6,1)) * 4 + 
                    parseInt(studIdNumber.substr(7,1)) * 3 + 
                    parseInt(studIdNumber.substr(8,1)) * 2 + 
                    parseInt(studIdNumber.substr(9,1));
         
            var checkNum = parseInt(studIdNumber.substr(10,1));
            //模數 - 總和/模數(10)之餘數若等於第九碼的檢查碼，則驗證成功
            //若餘數為0，檢查碼就是0
            if((s % 10) == 0 || (10 - s % 10) == checkNum){
                checkFg = true;
            }
        } else if (!isNaN(oIdNumber.substr(2,8)) &&
               (/^[A-Z]$/.test(oIdNumber.substr(0,1))) &&
               (/^[A-Z]$/.test(oIdNumber.substr(1,1)))){ 
            //外籍生，居留證號規則跟身分證號差不多，只是第二碼也是英文字母代表性別，跟第一碼轉換二位數字規則相同，但只取餘數
            //驗證填入身分證字號長度及格式
            //用正則表示式比對第一&&第二個字母是否為英文字母
            if (isNaN(oIdNumber.substr(2,8)) || 
               (!/^[A-Z]$/.test(oIdNumber.substr(0,1))) || 
               (!/^[A-Z]$/.test(oIdNumber.substr(1,1)))){
                return '證號格式錯誤';
            }
             
            //這邊把身分證字號轉換成準備要對應的
            studIdNumber = (idHeader.indexOf(oIdNumber.substring(0,1))+10) + 
            '' + ((idHeader.indexOf(oIdNumber.substr(1,1))+10) % 10) + '' + oIdNumber.substr(2,8);
            //開始進行身分證數字的相乘與累加，依照順序乘上1987654321
     
            s = parseInt(studIdNumber.substr(0,1)) + 
                parseInt(studIdNumber.substr(1,1)) * 9 + 
                parseInt(studIdNumber.substr(2,1)) * 8 + 
                parseInt(studIdNumber.substr(3,1)) * 7 +            
                parseInt(studIdNumber.substr(4,1)) * 6 + 
                parseInt(studIdNumber.substr(5,1)) * 5 + 
                parseInt(studIdNumber.substr(6,1)) * 4 + 
                parseInt(studIdNumber.substr(7,1)) * 3 + 
                parseInt(studIdNumber.substr(8,1)) * 2 + 
                parseInt(studIdNumber.substr(9,1));
     
            //檢查號碼 = 10 - 相乘後個位數相加總和之尾數。
            checkNum = parseInt(studIdNumber.substr(10,1));
            //模數 - 總和/模數(10)之餘數若等於第九碼的檢查碼，則驗證成功
            ///若餘數為0，檢查碼就是0
            if((s % 10) == 0 || (10 - s % 10) == checkNum){
                checkFg = true;
            }
        }
    }
    return (checkFg? '': '證號格式錯誤');
}

// private method for UTF-8 decoding  
function _utf8_decode (utftext) {
        var string = "";
        var i = 0, c = 0, c1 = 0, c2 = 0;
        while (i < utftext.length) {
            c = utftext.charCodeAt(i);
            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if ((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }
        }
        return string;
    }

export function encode (input) {
    var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = _utf8_encode(input);
    while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }
        output = output +
            _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
            _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
    }
    return output;
}

// public method for decoding  
export function decode (input) {
    var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    while (i < input.length) {
        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
            output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
            output = output + String.fromCharCode(chr3);
        }
    }
    output = _utf8_decode(output);
    return output;
}

function charMode (iN) {
    let ret = 0

    if ((iN >= 48) && (iN <= 57)) { // 數字
      ret = 1
    } else if ((iN >= 65) && (iN <= 90)) { // 大寫字母
      ret = 2
    } else if ((iN >= 97) && (iN <= 122)) { // 小寫
      ret = 4
    } else { // 特殊字符
      ret = 8
    }

    return ret
  }

  function bitTotal (num) {
    let modes = 0

    for (var i = 0; i < 4; i++) {
      if (num & 1) {
        modes++
      }
      num >>>= 1
    }

    return modes
  }

  export function checkStrong (sPW) {
    let modes = 0

    if (sPW.length <= 7) {
      return 1 // 密碼太短
    }

    for (var i = 0; i < sPW.length; i++) {
      // 測試每一個字符的類別並統計一共有多少種模式.
      modes |= charMode(sPW.charCodeAt(i))
    }

    return bitTotal(modes)
  }


// WEBPACK FOOTER //
// ./src/tool.js